import {formatDateTime, random, round2} from "../helpers/helpers";

export const generateBmsMetersDemo = () => {
    const now = new Date();

    const sensors = [
        {
            meter_id: 305,
            meter_name: "DG BATTERY",
            battery_voltage: round2(random(13.8, 14.4)),
            current: round2(random(0.5, 3.5)),
            percentage: 100,
            room_temp: round2(random(24, 30)),
            main_status: "On",
            status: "Online",
            last_seen: formatDateTime(now),
            cell_list: [],
        },
        {
            meter_id: 814,
            meter_name: "Fire Battery",
            battery_voltage: round2(random(13.6, 14.2)),
            current: round2(random(0.4, 2.8)),
            percentage: 100,
            room_temp: round2(random(23, 29)),
            main_status: "On",
            status: "Online",
            last_seen: formatDateTime(now),
            cell_list: [],
        },
    ];

    return {
        Total: sensors.length,
        Main_on: sensors.length,
        Main_off: 0,
        Status_on: sensors.length,
        Status_off: 0,
        cell_list: [],
        sensors,
    };
};
